// This is a mirror of PromptTemplateManagerFactory.ts - if that changes, we need to update this as well
export type PersonaId = 'generic-assistant' | 'potion-maker' | 'fortune-teller' | 'shopping-assistant' | 'virtual-idol';

// Persona constants to avoid hardcoding strings throughout the frontend
export const PERSONAS = {
  GENERIC_ASSISTANT: 'generic-assistant',
  POTION_MAKER: 'potion-maker', 
  FORTUNE_TELLER: 'fortune-teller',
  SHOPPING_ASSISTANT: 'shopping-assistant',
  VIRTUAL_IDOL: 'virtual-idol',
} as const satisfies Record<string, PersonaId>;

// Type-safe way to get all persona IDs
export const PERSONA_IDS = Object.values(PERSONAS);

// Default persona
export const DEFAULT_PERSONA: PersonaId = PERSONAS.GENERIC_ASSISTANT;